'use strict';

angular.module('directives.empStaging', [])

.directive('empStaging', ['$modal', function ($modal) {
    return {
        scope: {
            model: '=',
            boxNoContainer: '=?',
            readOnly: '=?',
            selectedMatching: '=?',
            boxContext: '=?',
            refreshMatchingsAndExceptions: '&?'
        },
        template: '<div ng-include="getTemplateUrl()"></div>',
        controller: ['$scope', function ($scope) {

            var matchingRulesCustomTemplateUrls = {
                'default': '/app/shared/components/directives/empStagingDirective-matching-default.tpl.html',
                'DetectEmployeeArrival': '/app/shared/components/directives/empStagingDirective-matching-DetectEmployeeArrival.tpl.html',
                'DetectEmployeeDeparture': '/app/shared/components/directives/empStagingDirective-matching-DetectEmployeePostDeparture.tpl.html',
                'DetectEmployeeContractRenewal': '/app/shared/components/directives/empStagingDirective-matching-DetectEmployeeContractRenewal.tpl.html',
                'DetectEmployeeRehire': '/app/shared/components/directives/empStagingDirective-matching-DetectEmployeeRehire.tpl.html',
                'DetectEmployeeUpdateProperties': '/app/shared/components/directives/empStagingDirective-matching-DetectEmployeeUpdateProperties.tpl.html',
                'DetectEmployeeUpdatePendingProperties': '/app/shared/components/directives/empStagingDirective-matching-DetectEmployeeUpdatePendingProperties.tpl.html',
                'DetectEmployeeNewSupervisor': '/app/shared/components/directives/empStagingDirective-matching-DetectEmployeeNewSupervisor.tpl.html',
                'DetectEmployeeNewStatus': '/app/shared/components/directives/empStagingDirective-matching-DetectEmployeeNewStatus.tpl.html',
            };

            $scope.getTemplateUrl = function () {
                var templateUrl;

                // Exception
                if ($scope.model.PubEmp_ExceptionStagingID) {
                    templateUrl = '/app/shared/components/directives/empStagingDirective-exception-' +
                                        $scope.model.PubEmp_ExceptionRuleLevelName + '.tpl.html';

                    return templateUrl;
                }

                // Matching
                if ($scope.model.PubEmp_MatchingRuleName) {
                    templateUrl = matchingRulesCustomTemplateUrls[$scope.model.PubEmp_MatchingRuleName] ||
                                    matchingRulesCustomTemplateUrls['default'];

                    return templateUrl;
                }

                // TODO: Throw exception here...
            };

            //$scope.getLayoutRatio = function () {
            //    if (_.isUndefined($scope.layoutRatio)) {
            //        return {
            //            photoColumn: 'col-md-3',
            //            infosColumn: 'col-md-5',
            //            supervisorColumn: 'col-md-4'
            //        };
            //    }
            //    return _.isString($scope.layoutRatio) ? $scope.$eval($scope.layoutRatio) : $scope.layoutRatio;
            //}
        }],
        link: function (scope, elem, attrs) {
        }
    }
}]);
